module.exports = __webpack_public_path__ + "img/ewa.1da006e1.png";